import {Component, Input} from '@angular/core';
import {MatTooltipModule} from "@angular/material/tooltip";

@Component({
  selector: 'app-info-tooltip',
  standalone: true,
  imports: [
    MatTooltipModule
  ],
  templateUrl: './info-tooltip.component.html',
  styleUrl: './info-tooltip.component.scss'
})
export class InfoTooltipComponent {

  @Input() tooltip: string;
  @Input() tooltipPosition: string = 'right';
  @Input() tooltipClass: string = 'custom-tooltip';

}
